import { h } from 'preact'

const FooterNavLink = ({ label, url }) => (
  <li><a href={url}>{label}</a></li>
)

export default FooterNavLink
